import _ from 'lodash';
import moment from 'moment';
import { POWER_CONTROL_UNIT_STATE } from '../../_config/consts';

export const ENERGY_ALERT_TYPES = {
  ON_TOO_LONG: 'ON_TOO_LONG',
  NEVER_SWITCHED_ON: 'NEVER_SWITCHED_ON',
  SENSOR_NOT_REPORTING: 'SENSOR_NOT_REPORTING',
  INHIBITED_TOO_LONG: 'INHIBITED_TOO_LONG',
};

export const ON_TOO_LONG_THRESHOLD_HOURS = 12;
export const INHIBITED_TOO_LONG_THRESHOLD_HOURS = 3;

const HOUR_MS = 60 * 60 * 1000;

export function isPcuPowered(pcu) {
  return !!pcu && (pcu.state === POWER_CONTROL_UNIT_STATE.POWER_ON || pcu.state === POWER_CONTROL_UNIT_STATE.GRACE_PERIOD);
}

export function computeOverviewFromUnits(units) {
  const list = units || [];
  const poweredUnits = _.filter(list, isPcuPowered);
  return {
    totalUnits: list.length,
    unitsOn: poweredUnits.length,
    unitsOff: list.length - poweredUnits.length,
    estimatedLoadKw: _.sumBy(poweredUnits, pcu => Number(pcu.nominalLoadKw) || 0),
  };
}

export function computeClientAlerts(units, now = moment().valueOf()) {
  return _.reduce(units || [], (alerts, pcu) => {
    if (!pcu.stateUpdatedAt) return alerts;
    const durationMs = now - moment(pcu.stateUpdatedAt).valueOf();
    if (isPcuPowered(pcu) && durationMs > ON_TOO_LONG_THRESHOLD_HOURS * HOUR_MS) {
      alerts.push({ pcuId: pcu.id, pcuName: pcu.name, type: ENERGY_ALERT_TYPES.ON_TOO_LONG, durationMs });
    }
    if (pcu.state === POWER_CONTROL_UNIT_STATE.INHIBITED && durationMs > INHIBITED_TOO_LONG_THRESHOLD_HOURS * HOUR_MS) {
      alerts.push({ pcuId: pcu.id, pcuName: pcu.name, type: ENERGY_ALERT_TYPES.INHIBITED_TOO_LONG, durationMs });
    }
    return alerts;
  }, []);
}

// BE alerts take priority over the client-side ones for the same unit and type
export function mergeAlerts(beAlerts, clientAlerts) {
  const alerts = _.uniqBy([...(beAlerts || []), ...(clientAlerts || [])], alert => `${alert.pcuId}_${alert.type}`);
  return _.orderBy(alerts, ['durationMs'], ['desc']);
}
